module.exports = __webpack_public_path__ + "img/fulfillment.a04dfe2f.svg";